import styled from "@emotion/styled"

const ShortDescriptionContainer = styled("ul")`
margin: 0;
padding: 0;
li {
  list-style: none;
}
`

export default ShortDescriptionContainer;